var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99967 0.666656H1.66634C0.933008 0.666656 0.333008 1.26666 0.333008 1.99999V10.6667C0.333008 11.0333 0.633008 11.3333 0.999674 11.3333C1.36634 11.3333 1.66634 11.0333 1.66634 10.6667V2.66666C1.66634 2.29999 1.96634 1.99999 2.33301 1.99999H8.99967C9.36634 1.99999 9.66634 1.69999 9.66634 1.33332C9.66634 0.966656 9.36634 0.666656 8.99967 0.666656ZM11.6663 3.33332H4.33301C3.59967 3.33332 2.99967 3.93332 2.99967 4.66666V14C2.99967 14.7333 3.59967 15.3333 4.33301 15.3333H11.6663C12.3997 15.3333 12.9997 14.7333 12.9997 14V4.66666C12.9997 3.93332 12.3997 3.33332 11.6663 3.33332ZM10.9997 14H4.99967C4.63301 14 4.33301 13.7 4.33301 13.3333V5.33332C4.33301 4.96666 4.63301 4.66666 4.99967 4.66666H10.9997C11.3663 4.66666 11.6663 4.96666 11.6663 5.33332V13.3333C11.6663 13.7 11.3663 14 10.9997 14Z",
    fill: "#344335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlack);
export default __webpack_public_path__ + "static/media/copy_black.798752bfe765a5af55d6117cb6f1866e.svg";
export { ForwardRef as ReactComponent };